/* eslint-disable react/display-name */
import React from 'react'

import SelectCreateable from '../SelectCreateable'
import SelectReact from '../SelectReact'
import SelectVirtualized from '../SelectVirtualized'
import { TSelect } from './types'

const Select = (props: TSelect): React.ReactElement => {
  const { isCreateable = false, isVirtualized = false, ...rest } = props

  if (isCreateable) {
    return <SelectCreateable {...rest} />
  }
  if (isVirtualized) {
    return <SelectVirtualized {...rest} />
  }

  return <SelectReact {...rest} />
}

export default Select
